import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./pages/homepage";
import Navbar from "./global/navbar";
import Footer from "./global/footer";

function App() {

  return (
        <Router>
          <Navbar />
          <Routes>
            <Route
              path="/"
              element={<HomePage />}
            />
          </Routes>
          <Footer />
        </Router>
  );
}

export default App;
